/**
 * `activation_type` sem entrada em `plugin_registry` (HUB-237, CA-11, ver
 * ADR-010) — `GET /plugin-registry/{type}` respondeu 404. Distinto de
 * `NetworkUnavailableError`: aqui a chamada foi feita e respondida com
 * sucesso pelo servidor, só não há plugin cadastrado para o tipo — não é
 * um erro retentável (CA-11: "o sistema não tenta carregar nenhuma URL").
 */
export class PluginNotRegisteredError extends Error {
  constructor(activationType: string) {
    super(`Nenhum plugin registrado para o tipo "${activationType}".`);
    this.name = 'PluginNotRegisteredError';
  }
}
